
import { withAuthRetry } from '../utils/authRetry';
import { ModifySectionRequest, ModifySectionResponse } from '../modifysection';

export async function modifySection(
    request: ModifySectionRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<ModifySectionResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/protobuf',
            'Authorization': 'Bearer ' + token
        };

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = `https://yivxudpoyjwik6yjtkmxedyj5y0iycda.lambda-url.us-west-2.on.aws/reviewservice/modifysection`;
        if (staging) {
            url = `https://43dim7ucbfrp62ivpzpjxtnszu0foonq.lambda-url.us-west-2.on.aws/reviewservice/modifysection-staging`;
        }

        const bodyBytes = ModifySectionRequest.encode(request).finish();

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: bodyBytes
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): ModifySectionResponse => {
        return ModifySectionResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
